// extracted by mini-css-extract-plugin
export default {"box":"footer_box__I-NQ1","input":"footer_input__3mAN4","box1":"footer_box1__eZ72C","mapa":"footer_mapa__SnuzB","texto":"footer_texto__aLsO2"};